import { useQuery } from 'react-query'
import { getServiceProviders } from '../../../utils/badaAppointmentApi'

export const useServiceProviders = (storeId, subsystem, serviceId, includeHidden, disabled) =>
    useQuery(
      ['useServiceProviders', storeId, subsystem, serviceId, includeHidden],
      () => getServiceProviders(storeId, subsystem, serviceId, includeHidden),
      { enabled: !!storeId && !!serviceId && !disabled }
    )
